import { render, staticRenderFns } from "./rc-alert.vue?vue&type=template&id=25175232&scoped=true&"
import script from "./rc-alert.vue?vue&type=script&lang=js&"
export * from "./rc-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25175232",
  null
  
)

export default component.exports